
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20.002 20"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-onboard-tool"}},[_c('rect',{attrs:{"id":"Rectangle_15172","data-name":"Rectangle 15172","width":"20.002","height":"20","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_45283","data-name":"Group 45283"}},[_c('g',{attrs:{"id":"Group_45278","data-name":"Group 45278","transform":"translate(0 -.001)","clip-path":"url(#clip-path-onboard-tool)"}},[_c('path',{attrs:{"id":"Path_32390","data-name":"Path 32390","d":"M19.369 8.762a2.47 2.47 0 00-.913-.913L5.422.332A2.482 2.482 0 001.7 2.481v15.033a2.483 2.483 0 003.723 2.153l13.032-7.516a2.479 2.479 0 00.917-3.386zm-1.773 1.9l-13.03 7.517a.788.788 0 01-1.148-.666V2.484a.764.764 0 01.765-.764.757.757 0 01.377.1l13.035 7.517a.764.764 0 010 1.326z","transform":"translate(0 .001)","fill":"#262626"}})])])])
          )
        }
      }
    